import React from "react";

import { RouteInfoType } from "../../types/types";

import StatisticsPage from "./pages/statistics";


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingBag, faChartBar } from '@fortawesome/free-solid-svg-icons'
import OrdersLayout from "./StatsLayout";
import ShowOrderDetailsForm from "./pages/ordersData/components/ShowDetailsForm";
import ViewBookingPage from "./pages/bookingOrders/pages/viewBookingPage/ViewBookingPage";
import OrdersList from "./pages/ordersData/OrdersList";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import BookingsList from "./pages/bookingOrders/pages/bookingList/BookingsList";


const ordersRoutes = [
    {
        id: "orders",
        path: "/stats/",
        header: "sales",
        name: "onlineSales",
        icon: <FontAwesomeIcon icon={faShoppingBag as IconProp} size={"lg"}/>,
        component: OrdersLayout,
        nonCollapsable: true,
        routes: [
            {
                path: "/stats/general",
                name: "stats",
                component: StatisticsPage,
                icon: <FontAwesomeIcon icon={faChartBar as IconProp} size={"lg"}/>,
            },
           {
                path: "/stats/list",
                name: "orders",
                component: OrdersList,
                icon: <FontAwesomeIcon icon={faShoppingBag as IconProp} size={"lg"}/>,
           },
           {
                path: "/stats/orders/:orderId",
                name: "orderDetails",
                component: ShowOrderDetailsForm,
                hide: true,
           },
            {
                path: "/stats/booking/list",
                name: "bookings",
                component: BookingsList,
                icon: <FontAwesomeIcon icon={faShoppingBag as IconProp} size={"lg"}/>,
            },
            {
                path: "/stats/bookings/:bookingId/view",
                name: "bookingDetails",
                component: ViewBookingPage,
                icon: <FontAwesomeIcon icon={faShoppingBag as IconProp} size={"lg"}/>,
                hide: true
            },
            /*{
                path: "/branches/deliverySettings",
                name: "Доставка",
                component: OrganizationBranchesList,
            },
            {
                path: "/branches/paymentSettings",
                name: "Оплата",
                component: OrganizationBranchesList,
            },
            {
                hide: true,
                path: "/branches/:id/view",
                name: "Список",
                component: OrganizationBranchesList,
            },*/
        ]
    },

] as RouteInfoType[];


export default ordersRoutes;
